import NewsDetail from './news-detail';

export default NewsDetail;
